import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

import { AButton } from '../atoms';

export default function OCookieConsent({ onClick }) {
	return (
		<section className="o-cookie-consent">
			<p>
				<FormattedMessage id="COOKIE_CONSENT.BODY" defaultMessage="" />
			</p>
			<AButton
				value="COOKIE_CONSENT.BUTTON"
				onClick={onClick}
			/>
		</section>
	);
}

OCookieConsent.propTypes = {
	onClick: PropTypes.func.isRequired,
};



// WEBPACK FOOTER //
// ./src/components/organisme/_organisme.cookie-consent.js